export default class VideoAutoplay {
  constructor(el) {
    this.videoEl = el;
    this.pauseButtonEl = document.querySelector(
      `[data-video-id="${this.videoEl.id}"]`
    );

    this.state = new Proxy(
      {
        paused: true,
        reducedMotionPreferred: false,
      },
      {
        set: (target, property, value) => {
          target[property] = value;
          switch (property) {
            case "paused":
              this.processPausedChange(value);
              break;
            case "reducedMotionPreferred":
              this.processReducedMotionPreferredChange(value);
              break;
            default:
              break;
          }
          return true;
        },
      }
    );

    this.reducedMotionQuery = window.matchMedia(
      `(prefers-reduced-motion: reduce)`
    );

    if (this.reducedMotionQuery.matches) {
      this.state.reducedMotionPreferred = true;
    }

    this.bindEvents();
  }

  get isHeroVideo() {
    return this.videoEl.dataset.heroVideo === "true";
  }

  bindEvents() {
    this.pauseButtonEl?.addEventListener("click", this.onPauseClick);

    this.reducedMotionQuery.addEventListener("change", ({ matches }) => {
      this.state.reducedMotionPreferred = matches;
    });

    const headerHeight =
      getComputedStyle(document.documentElement)
        .getPropertyValue("--header-height")
        .trim() || "0px";

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (this.state.reducedMotionPreferred) return;
        this.state.paused = !entry.isIntersecting;
      },
      {
        threshold: this.isHeroVideo
          ? 0.65
          : window.innerWidth <= 550
          ? 0.5
          : 0.75,
        rootMargin: `${
          this.isHeroVideo || window.innerWidth <= 550
            ? "0px"
            : `-${headerHeight}`
        } 0px 0px 0px`,
      }
    );
    this.observer.observe(this.videoEl);
  }

  onPauseClick = () => {
    const prevPaused = this.state.paused;
    this.state.paused = !prevPaused;
  };

  processPausedChange() {
    const { paused } = this.state;

    if (!this.videoEl) return;

    this.videoEl.dataset.paused = `${paused}`;

    if (this.pauseButtonEl) {
      this.pauseButtonEl.dataset.paused = `${paused}`;
    }

    if (paused) {
      this.videoEl.pause();
    } else {
      this.videoEl.play().catch(() => {});
    }
  }

  processReducedMotionPreferredChange() {
    const { reducedMotionPreferred } = this.state;

    if (reducedMotionPreferred) {
      this.videoEl.removeAttribute("autoplay");

      this.state.paused = true;
    }

    if (this.pauseButtonEl) {
      this.pauseButtonEl.hidden = !reducedMotionPreferred;
    }
  }
}
